/**
 * rendi-consent-offset — keep the bottom-pinned consent banner from covering
 * the wizard's fixed footer.
 *
 * The consent banner is pinned to bottom:0 with a max z-index. On this marketing
 * landing it would hide the only "Prosegui" CTA until the visitor accepts. We
 * measure the banner and publish its height as --rendi-cookie-offset so the
 * footer can sit above it (and the form can reserve matching space) until it's
 * dismissed. The CSS falls back to 0px when this script doesn't run.
 *
 * The selector list carries one entry per consent app the storefront has worn:
 * Pandectes hides its banner on dismiss, iubenda removes it, and a measured
 * height of 0 covers both.
 */
(function () {
  const BANNER_SELECTOR = '.pd-cookie-banner-window, .cc-window.cc-banner, #iubenda-cs-banner';
  const OFFSET_VAR = '--rendi-cookie-offset';

  let rafId = null;
  const resizeObserver = new ResizeObserver(publishOffset);
  const observed = new WeakSet();

  // Single source of truth: re-resolve the banners (they're injected async and
  // hidden or removed on dismiss), observe every one so any of them growing
  // republishes, then publish the tallest.
  //
  // Tallest rather than first match: querySelector answers in document order,
  // so while two consent apps overlap a dismissed banner sitting at height 0
  // would mask the live one.
  function publishOffset() {
    let height = 0;
    for (const candidate of document.querySelectorAll(BANNER_SELECTOR)) {
      if (!observed.has(candidate)) {
        observed.add(candidate);
        resizeObserver.observe(candidate);
      }
      height = Math.max(height, candidate.getBoundingClientRect().height);
    }
    document.documentElement.style.setProperty(OFFSET_VAR, `${Math.round(height)}px`);
  }

  // Watch the body so we catch the banner being injected and removed.
  // subtree:true is defensive about injection depth; requestAnimationFrame
  // coalesces the mutation bursts a wizard step change produces.
  const mutationObserver = new MutationObserver(function () {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      publishOffset();
    });
  });

  mutationObserver.observe(document.body, { childList: true, subtree: true });
  publishOffset();
})();
